export default __webpack_public_path__ + "static/media/messageInfoDarkSecondary32.6290fae2.svg";